import { render, staticRenderFns } from "./FolderList.vue?vue&type=template&id=2579cc0c&scoped=true"
import script from "./FolderList.vue?vue&type=script&lang=js"
export * from "./FolderList.vue?vue&type=script&lang=js"
import style0 from "./FolderList.vue?vue&type=style&index=0&id=2579cc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2579cc0c",
  null
  
)

export default component.exports